module.exports = __webpack_public_path__ + "img/mystery.b667653a.png";